import React from "react";
import { Link } from "react-router-dom";
import cn from "classnames";
import Slider from "react-slick";
import Icon from "../../../components/Icon";
import ScrollParallax from "../../../components/ScrollParallax";
import styles from "./Comment.module.sass";

const items = [
  {
    title: "Tableau de bord",
    url: "/rapports-statistiques",
    image: "/images/content/dashboard.png",
    image2x: "/images/content/dashboard@2x.png",
    content: "Interface centralisée avec alertes automatiques pour suivre tous vos contrats d'apprentissage en temps réel",
  },
  {
    title: "Signature électronique",
    url: "/contrat-apprentissage",
    image: "/images/content/signature.png",
    image2x: "/images/content/signature@2x.png",
    content: "Processus de signature numérique sécurisé pour employeurs, élèves et écoles avec validation juridique",
  },
  {
    title: "Documents officiels",
    url: "/contrat-apprentissage",
    image: "/images/content/documents.png",
    image2x: "/images/content/documents@2x.png",
    content: "Génération automatique des CERFA et conventions avec pré-remplissage intelligent des données",
  },
  {
    title: "Gestion OPCO",
    url: "/opco",
    image: "/images/content/opco.png",
    image2x: "/images/content/opco@2x.png",
    content: "Transmission automatique des dossiers complets aux organismes de financement avec suivi en temps réel",
  },
  {
    title: "Module d'émargement",
    url: "/emargement-assiduite",
    image: "/images/content/emargement.png",
    image2x: "/images/content/emargement@2x.png",
    content: "Système complet de suivi des heures avec rapports d'absences et d'assiduité automatisés",
  },
  {
    title: "Facturation & Échéanciers",
    url: "/opco",
    image: "/images/content/billing.png",
    image2x: "/images/content/billing@2x.png",
    content: "Système de facturation intégré avec gestion automatisée des échéanciers de paiement OPCO",
  },
];

const SlickArrow = ({ currentSlide, slideCount, children, ...props }) => (
  <button {...props}>{children}</button>
);

const Comment = () => {
  const settings = {
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    nextArrow: (
      <SlickArrow>
        <Icon name="arrow-next" size="14" />
      </SlickArrow>
    ),
    prevArrow: (
      <SlickArrow>
        <Icon name="arrow-prev" size="14" />
      </SlickArrow>
    ),
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  return (
    <div className={cn("section", styles.section)}>
      <div className={cn("container", styles.container)}>
        <div className={styles.wrapper}>
          <div className={styles.head}>
            <h2 className={cn("h2", styles.title)}>En savoir plus sur nos fonctionnalités</h2>
            <div className={styles.info}>
              Découvrez en détail toutes les fonctionnalités de Edutio qui vous permettront 
              d'automatiser et d'optimiser la gestion de vos contrats d'apprentissage au quotidien.
            </div>
          </div>
          <div className={styles.wrap}>
            <Slider className="comment-slider" {...settings}>
              {items.map((x, index) => (
                <ScrollParallax className={styles.slide} key={index}>
                  <Link className={cn("comment-item", styles.item)} to={x.url}>
                    <div className={styles.preview}>
                      <img
                        srcSet={`${x.image2x} 2x`}
                        src={x.image}
                        alt={x.title}
                      />
                    </div>
                    <div className={styles.subtitle}>{x.title}</div>
                    <div className={styles.content}>{x.content}</div>
                  </Link>
                </ScrollParallax>
              ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Comment;
